import { cn } from "@oneleet/utils";

export const CircleSoc2 = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-6", className)}
    >
      <g clipPath="url(#clip0_124_2582)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#0067D6"
        />
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="url(#paint0_linear_124_2582)"
        />
        <path
          d="M12 22C17.5229 22 22 17.5228 22 12C22 6.47713 17.5229 1.99997 12 1.99997C6.47716 1.99997 2 6.47713 2 12C2 17.5228 6.47716 22 12 22Z"
          fill="#0067D6"
        />
        <path
          d="M12 22C17.5229 22 22 17.5228 22 12C22 6.47713 17.5229 1.99997 12 1.99997C6.47716 1.99997 2 6.47713 2 12C2 17.5228 6.47716 22 12 22Z"
          fill="url(#paint1_linear_124_2582)"
        />
        <path
          d="M4.60693 11.2714L5.92351 7.62001H6.8492L8.16578 11.2714H7.3532L7.08578 10.4948H5.68179L5.41437 11.2714H4.60693ZM5.90293 9.85201H6.86978L6.38636 8.44285L5.90293 9.85201ZM8.47016 7.62001H9.2519V11.2714H8.47016V7.62001ZM12.9444 9.95485C12.7953 10.8394 12.2296 11.3537 11.3553 11.3537C10.2753 11.3537 9.59642 10.536 9.59642 9.45085C9.59642 8.36569 10.2753 7.53769 11.3553 7.53769C12.1936 7.53769 12.7696 8.03143 12.929 8.87485L12.1164 8.91085C12.0238 8.45317 11.741 8.19601 11.3398 8.19601C10.697 8.19601 10.3987 8.73601 10.3987 9.45085C10.3987 10.1606 10.7022 10.6954 11.3398 10.6954C11.7667 10.6954 12.0444 10.4177 12.1267 9.92401L12.9444 9.95485ZM14.7275 7.62001C15.6018 7.62001 16.1315 8.07259 16.1315 8.81317C16.1315 9.55369 15.6018 10.0114 14.7275 10.0114H14.0486V11.2714H13.2669V7.62001H14.7275ZM14.0486 9.35317H14.6812C15.0926 9.35317 15.3292 9.16801 15.3292 8.81317C15.3292 8.45827 15.0926 8.27827 14.6812 8.27827H14.0486V9.35317ZM15.8326 11.2714L17.1492 7.62001H18.0749L19.3915 11.2714H18.5789L18.3115 10.4948H16.9075L16.6401 11.2714H15.8326ZM17.1286 9.85201H18.0955L17.6121 8.44285L17.1286 9.85201ZM6.07754 15.432C6.14438 15.8228 6.42212 16.08 6.87986 16.08C7.22954 16.08 7.46612 15.9412 7.46096 15.6737C7.45586 15.4063 7.22954 15.252 6.6587 15.1132C5.86669 14.9228 5.35755 14.604 5.35755 14.0177C5.35755 13.3543 5.91298 12.9377 6.74612 12.9377C7.5587 12.9377 8.11412 13.4366 8.20154 14.172L7.41986 14.2132C7.3787 13.8274 7.11128 13.5857 6.72554 13.5857C6.38612 13.5857 6.14438 13.7606 6.15986 14.028C6.17012 14.3366 6.53012 14.4394 6.92096 14.5372C7.7387 14.7172 8.25812 15.0668 8.25812 15.648C8.25812 16.3423 7.64612 16.7332 6.85928 16.7332C5.96955 16.7332 5.34212 16.2394 5.29069 15.468L6.07754 15.432ZM10.2984 16.7537C9.18752 16.7537 8.52404 16.0234 8.52404 14.8508C8.52404 13.668 9.18752 12.9377 10.2984 12.9377C11.4092 12.9377 12.0778 13.668 12.0778 14.8508C12.0778 16.0234 11.4092 16.7537 10.2984 16.7537ZM9.33152 14.8508C9.33152 15.6326 9.69152 16.0954 10.2984 16.0954C10.9155 16.0954 11.2704 15.6326 11.2704 14.8508C11.2704 14.064 10.9155 13.596 10.2984 13.596C9.69152 13.596 9.33152 14.064 9.33152 14.8508ZM15.639 15.3548C15.4899 16.2394 14.9241 16.7537 14.0499 16.7537C12.9699 16.7537 12.291 15.936 12.291 14.8508C12.291 13.7657 12.9699 12.9377 14.0499 12.9377C14.8881 12.9377 15.4641 13.4314 15.6236 14.2748L14.811 14.3108C14.7184 13.8532 14.4356 13.596 14.0344 13.596C13.3916 13.596 13.0933 14.136 13.0933 14.8508C13.0933 15.5606 13.3967 16.0954 14.0344 16.0954C14.4613 16.0954 14.739 15.8177 14.8213 15.324L15.639 15.3548ZM15.9351 14.1823C15.9967 13.4623 16.5419 12.9377 17.3493 12.9377C18.1156 12.9377 18.6659 13.4057 18.6659 14.0486C18.6659 14.6092 18.2185 14.9332 17.7196 15.2212C17.5191 15.3343 16.8813 15.7148 16.8607 16.0132H18.6762V16.6714H15.9093C15.9093 15.6017 16.5111 15.1132 17.2567 14.6914C17.6271 14.4652 17.8636 14.2748 17.8636 14.0383C17.8636 13.7812 17.6527 13.596 17.3493 13.596C17.0202 13.596 16.8042 13.8223 16.7373 14.2286L15.9351 14.1823Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_124_2582"
          x1="24"
          y1="24"
          x2="-0.300008"
          y2="9.42283e-06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" stopColor="#01B0F7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_124_2582"
          x1="22"
          y1="22"
          x2="1.75004"
          y2="2.00002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#01B0F7" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_124_2582">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
